import { render, staticRenderFns } from "./tblmainMtbe.vue?vue&type=template&id=70e21d97&"
import script from "./tblmainMtbe.vue?vue&type=script&lang=js&"
export * from "./tblmainMtbe.vue?vue&type=script&lang=js&"
import style0 from "./tblmainMtbe.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports